import { EditOutlined, BulbOutlined, GlobalOutlined } from "@ant-design/icons";
export const AI_ACTIONS = {
  SUMMARIZE_CONVERSATION: "summarize_conversation",
  SUGGEST_REPLIES: "suggest_replies",
  TRANSLATE: "translate",
  FORMAT_TEXT: "format_text",
};

export const LANGUAGES = [
  { label: "English", value: "English" },
  { label: "Hindi", value: "Hindi" },
  { label: "Gujarati", value: "Gujarati" },
  { label: "Punjabi", value: "Punjabi" },
];

export const AI_ACTION_CONFIG = {
  [AI_ACTIONS.TRANSLATE]: {
    label: "Translate",
    icon: <EditOutlined />,
    buttonLabel: "Translate Message",
  },
  [AI_ACTIONS.FORMAT_TEXT]: {
    label: "Format",
    icon: <GlobalOutlined />,
    buttonLabel: "Format Message",
  },
  [AI_ACTIONS.SUGGEST_REPLIES]: {
    label: "Suggest",
    icon: <BulbOutlined />,
    buttonLabel: "Suggest Replies",
  },
};

export const CUSTOMER_LOGIN = "https://app.kelu.uk/auth/signin";

export const APP_EMAIL = "hello@kelu.uk";
